import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-empty-page',
    template: ``,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmptyPageComponent {}
